import React from 'react'
import { createTimeLine } from './createTimeline'

class TimeLine extends React.Component {
  constructor(props) {
    super(props)
    this.listRef = React.createRef()
  }

  getTimeLine({ formatter = x => x, fromTime, toTime }) {
    const { interval } = this.props //eslint-disable-line
    return createTimeLine(new Date(fromTime.getTime()), new Date(toTime.getTime()), interval).map(formatter)
  }

  render() {
    const { children } = this.props //eslint-disable-line
    return this.getTimeLine(this.props).map((...t) => children(...t))
  }
}

export default TimeLine
